import React from "react";
import PageHeader from "../../../../components/PageHeader/PageHeader";
import { useTranslation } from "react-i18next";
import {
  Box,
  FormHelperText,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker";
import { useFormikContext } from "formik";
import DynamicDropDownlist from "../../../AddNewVehicles/components/DynamicDropDownlist";
import {
  searchBroker,
  searchDestination,
  searchPickupTerminal,
  searchPortLoading,
  searchReturnTerminal,
  searchShippingLine,
} from "../../../../actions/formAction";
import PropTypes from "prop-types";

function BookingInformation({ disabled }) {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <>
      <PageHeader title={t("Booking Information")} />

      <Box
        sx={{
          margin: { xs: "24px 0", md: "64px 49px" },
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
          pb: { xs: 2, md: 0 },

        }}
      >
        <CustomDatePicker
          disabled={true}
          label={t("entryDate")}
          name="entryDate"
          disableFuture={true}
        />

        <Box display="flex" flexDirection="column">
          <TextField
            label={t("Booking Number")}
            variant="outlined"
            disabled={disabled}
            name="number"
            value={formik.values.number || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.number && Boolean(formik.errors.number)}
          />
          {formik.touched.number && formik.errors.number && (
            <FormHelperText error>{formik.errors.number}</FormHelperText>
          )}
        </Box>

        <DynamicDropDownlist
          label="destination"
          formik={formik}
          fieldName="destination"
          disabled={disabled}
          loadingKey="isLoadingDestinationData"
          dataKey="destination"
          fetchAction={searchDestination}
          errorKey="destination"
        />

        <DynamicDropDownlist
          label="portLoading"
          formik={formik}
          fieldName="portLoading"
          disabled={disabled}
          loadingKey="isLoadingPortData"
          dataKey="portLoading"
          fetchAction={searchPortLoading}
          errorKey="portLoading"
        />
      </Box>




      <Box
        sx={{
          display: "grid",
          margin: { xs: "24px 0", md: "64px 49px" },
          gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
          pt: { xs: 2, md: 0 },
          pb: { xs: 2, md: 0 },
        }}
      >

        <Box display="flex" flexDirection="column">
          <TextField
            label={t("Vessel Name")}
            variant="outlined"
            name="vesselName"
            disabled={disabled}
            value={formik.values.vesselName || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.vesselName && Boolean(formik.errors.vesselName)
            }
          />
          {formik.touched.vesselName && formik.errors.vesselName && (
            <FormHelperText error>{formik.errors.vesselName}</FormHelperText>
          )}
        </Box>

        <Box display="flex" flexDirection="column">
          <TextField
            label={t("Voyage Number")}
            variant="outlined"
            name="voyageNumber"
            disabled={disabled}
            value={formik.values.voyageNumber || ""}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.voyageNumber && Boolean(formik.errors.voyageNumber)
            }
          />
          {formik.touched.voyageNumber && formik.errors.voyageNumber && (
            <FormHelperText error>{formik.errors.voyageNumber}</FormHelperText>
          )}
        </Box>








      </Box>

      <Box
        sx={{
          display: "grid",
          margin: { xs: "24px 0", md: "64px 49px" },
          gridTemplateColumns: { xs: "1fr", md: "repeat(4, 1fr)" },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
        }}
      >
        <DynamicDropDownlist
          label="Return Terminal"
          formik={formik}
          fieldName="returnTerminal"
          disabled={disabled}
          loadingKey="isLoadingReturnTerminalData"
          dataKey="returnTerminal"
          fetchAction={searchReturnTerminal}
          errorKey="returnTerminal"
        />

        <DynamicDropDownlist
          label="shippingLine"
          formik={formik}
          fieldName="shippingLine"
          disabled={disabled}
          loadingKey="isLoadingShippingLineData"
          dataKey="shippingLine"
          fetchAction={searchShippingLine}
          errorKey="shippingLine"
        />
        <DynamicDropDownlist
          label="Broker"
          formik={formik}
          fieldName="broker"
          disabled={disabled}
          loadingKey="isLoadingBrokerData"
          dataKey="broker"
          fetchAction={searchBroker}
          errorKey="broker"
        />





        <DynamicDropDownlist
          label="Pickup Terminal"
          formik={formik}
          fieldName="pickupTerminal"
          disabled={disabled}
          loadingKey="isLoadingPickupTerminalData"
          dataKey="pickupTerminal"
          fetchAction={searchPickupTerminal}
          errorKey="pickupTerminal"
        />




      </Box>



      <Box
        sx={{
          display: "grid",
          margin: { xs: "24px 0", md: "64px 49px" },
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
          pt: { xs: 2, md: 0 },
          pb: { xs: 2, md: 0 },
        }}
      >


        <CustomDatePicker
          disabled={disabled}
          label={t("Estimated Sailing Date")}
          name="estimatedSailingDate"
          disableFuture={true}
        />

        <CustomDatePicker
          disabled={disabled}
          label={t("Estimated Arrival Date")}
          name="estimatedArrivalDate"
          disableFuture={true}
        />
        <CustomDatePicker
          disabled={disabled}
          label={t("Earliest Receiving Date")}
          name="earliestReceivingDate"
          disableFuture={true}
        />

        <CustomDatePicker
          disabled={disabled}
          label={t("Latest Return Date")}
          name="latestReturnDate"
          disableFuture={true}
        />

        <CustomDatePicker
          disabled={disabled}
          label={t("DOC Cutoff Date")}
          name="cutoffDate"
          disableFuture={true}
        />
      </Box>



      <Box
        sx={{
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
        }}
      >
        <TextareaAutosize
          sx={{
            background: "#fff",
            minHeight: "90px",
            width: "100%",
            border: "1px solid #D9DCE1",
            borderRadius: "8px",
          }}
          name="note"
          style={{
            background: "#fff",
            minHeight: "90px",
            width: "100%",
            border: "1px solid #D9DCE1",
            borderRadius: "8px",
            padding: "10px",
            resize: "none",
            fontFamily: "inherit",
            fontSize: 15,
          }}
          placeholder={"Note (optional)"}
          value={formik.values.note || ""}
          onChange={formik.handleChange}
          disabled={disabled}
        />
      </Box>
    </>
  );
}


BookingInformation.propTypes = {
  disabled: PropTypes.bool,
};
export default BookingInformation;
